__webpack_require__.p = "https://static.age.awaze.com/search-mfe/03fa3ba/_next/";